import e from "../Typography/Typography.module.js";
import "../Typography/index.js";
import t from "./Notification.module.js";
import { c as n } from "react/compiler-runtime";
import { Button as r } from "@jetbrains/ring-ui-built/components/button/button.js";
import i from "classnames";
import { Fragment as a, createElement as o, useState as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import u from "@jetbrains/icons/chevron-20px-down.js";
import d from "@jetbrains/icons/close.js";
//#region src/components/Notification/Notification.tsx
var f = (a) => {
	let o = n(46), f, h, g, _, v, y, b, x, S, C;
	o[0] === a ? (f = o[1], h = o[2], g = o[3], _ = o[4], v = o[5], y = o[6], b = o[7], x = o[8], S = o[9], C = o[10]) : ({className: g, children: h, type: C, title: S, onClose: _, actions: f, collapsible: b, onCollapseChange: v, isCollapsed: x, ...y} = a, o[0] = a, o[1] = f, o[2] = h, o[3] = g, o[4] = _, o[5] = v, o[6] = y, o[7] = b, o[8] = x, o[9] = S, o[10] = C);
	let w = b !== void 0 && b, [T, E] = s(x !== void 0 && x), D;
	o[11] !== T || o[12] !== v ? (D = () => {
		v && v(!T), E(p);
	}, o[11] = T, o[12] = v, o[13] = D) : D = o[13];
	let O = D, k = t[C], A = !h, j;
	o[14] !== g || o[15] !== k || o[16] !== A ? (j = i(t.wrapper, g, k, { [t.inline]: A }), o[14] = g, o[15] = k, o[16] = A, o[17] = j) : j = o[17];
	let M;
	o[18] === Symbol.for("react.memo_cache_sentinel") ? (M = i(t.container, e.text), o[18] = M) : M = o[18];
	let N;
	o[19] !== T || o[20] !== S ? (N = S && /* @__PURE__ */ c("header", {
		className: i(t.header, { [t.isCollapsed]: T }),
		children: S
	}), o[19] = T, o[20] = S, o[21] = N) : N = o[21];
	let P;
	o[22] !== w || o[23] !== _ ? (P = _ && !w && /* @__PURE__ */ c(r, {
		"aria-label": "Close",
		onClick: _,
		icon: d
	}), o[22] = w, o[23] = _, o[24] = P) : P = o[24];
	let F;
	o[25] !== N || o[26] !== P ? (F = /* @__PURE__ */ l("div", {
		className: t.titleContainer,
		children: [N, P]
	}), o[25] = N, o[26] = P, o[27] = F) : F = o[27];
	let I;
	o[28] !== h || o[29] !== T ? (I = !T && /* @__PURE__ */ c("div", { children: h }), o[28] = h, o[29] = T, o[30] = I) : I = o[30];
	let L;
	o[31] !== w || o[32] !== O || o[33] !== T ? (L = w && /* @__PURE__ */ c(r, {
		"aria-label": T ? "Expand" : "Collapse",
		className: i({ [t.isCollapsed]: T }),
		onClick: O,
		icon: u,
		iconClassName: t.chevronIcon
	}), o[31] = w, o[32] = O, o[33] = T, o[34] = L) : L = o[34];
	let R;
	o[35] !== I || o[36] !== L || o[37] !== F ? (R = /* @__PURE__ */ l("div", {
		className: M,
		children: [
			F,
			I,
			L
		]
	}), o[35] = I, o[36] = L, o[37] = F, o[38] = R) : R = o[38];
	let z;
	o[39] === f ? z = o[40] : (z = f && /* @__PURE__ */ c("div", {
		className: t.actions,
		children: f.map(m)
	}), o[39] = f, o[40] = z);
	let B;
	return o[41] !== y || o[42] !== R || o[43] !== z || o[44] !== j ? (B = /* @__PURE__ */ l("div", {
		className: j,
		...y,
		children: [R, z]
	}), o[41] = y, o[42] = R, o[43] = z, o[44] = j, o[45] = B) : B = o[45], B;
};
function p(e) {
	return !e;
}
function m(e) {
	if ("custom" in e) return /* @__PURE__ */ c(a, { children: e.custom }, e.key);
	let { children: t, key: n, ...i } = e;
	return /* @__PURE__ */ o(r, {
		...i,
		key: n,
		"data-test": n
	}, t);
}
//#endregion
export { f as Notification };
